import { EventName, EventType, MetricsForJumboEvent } from '../constants';
import { createAndSendEvent } from '../jumboClient';
import { stringifyFeatureMeta } from '../utils';

// jumboClient's own stringifier drops falsy values (`false`/`0`, not just
// objects/arrays) from `feature_meta` - every RFO event funnels through
// here so that's normalized once, rather than at each call site.
const send = (eventName, properties = {}, eventType) => {
  const metaKey = MetricsForJumboEvent.feature_meta;
  const normalizedProperties = properties[metaKey]
    ? { ...properties, [metaKey]: stringifyFeatureMeta(properties[metaKey]) }
    : properties;
  createAndSendEvent(eventName, normalizedProperties, eventType);
};

export const RfoApplicableReasonsFetchedEvent = (properties = {}) =>
  send(EventName.RFO_APPLICABLE_REASONS_FETCHED, properties, EventType.SHOWN);

export const RfoCacrOptionClickedEvent = (properties = {}) =>
  send(EventName.RFO_CACR_OPTION_CLICKED, properties);

export const RfoIssueInfoResponseEvent = (properties = {}) =>
  send(EventName.RFO_ISSUE_INFO_RESPONSE, properties, EventType.SHOWN);

export const RfoCancellationReasonSelectedEvent = (properties = {}) =>
  send(EventName.RFO_CANCELLATION_REASON_SELECTED, properties);

export const RfoEvaluateResponseEvent = (properties = {}) =>
  send(EventName.RFO_EVALUATE_RESPONSE, properties);

export const RfoSubmitCtaClickedEvent = (properties = {}) =>
  send(EventName.RFO_SUBMIT_CTA_CLICKED, properties);
